import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-template-halves',
  templateUrl: './template-halves.component.html',
  styleUrls: ['./template-halves.component.scss']
})
export class TemplateHalvesComponent {
  @Input() noPadding = false;
  @Input() border = false;
}
